export const SETTINGS_ROUTE = '/settings';
export const SETTINGS_EXIT_CRITERIA_ROUTE = `${SETTINGS_ROUTE}/exit-criteria`;
export const SETTINGS_YEARS_ROUTE = `${SETTINGS_ROUTE}/years`;
export const SETTINGS_PLANS_ROUTE = `${SETTINGS_ROUTE}/plans`;

export type SettingsTab = 'exit-criteria' | 'years' | 'plans';
